<span class="close-icon" [mat-dialog-close]="true" style="cursor: pointer">
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.26211 15.9621L0.0371094 14.7371L6.77461 7.99961L0.0371094 1.26211L1.26211 0.0371094L7.99961 6.77461L14.7371 0.0371094L15.9621 1.26211L9.22461 7.99961L15.9621 14.7371L14.7371 15.9621L7.99961 9.22461L1.26211 15.9621Z" fill="#ACACAC"/>
    </svg>
</span>
<div class="box-video-recording">
    <div class="image-recording algin-center w-100">
        <img class="recording"
        src="../../../../../assets/images/recording.png" 
        alt="recording" />
        <h2 class="font-bold" style="color:#000000">{{'StartSimulation.DidYouStartVideoRecording' | translate}}</h2>
    </div>
    <button class="btn-yes-recording font-bold btn-common-style" (click)="btnStartedRecording()">{{'StartSimulation.BtnYes' | translate}}</button>
    <button mat-button class="btn-no-recording font-bold" (click)="btnStartedRecording()">{{'StartSimulation.BtnNo' | translate}}</button>
</div>
